$(document).ready(function(){

    $('.js-scrollTo').click(function(e) {
        let target = $($(this).attr('data-target'));
        if(target.length){
            scrollTo( $($(this).attr('data-target')), $(this).attr('data-tab')  );
            e.preventDefault();
        }
    })

    $('.js-menu-scroll').click(function(){
        let tab = $(this).data('tab');

        if(typeof tab == 'undefined'){
            tab = false;
        }

        let target_selector = $('a', this).attr('href');
        /* if url, get only selector */
        let parts = target_selector.split('/');
        let selector = parts[parts.length - 1];

        scrollTo( $(selector), tab );
        mobile_menu_close(1);
    })

    $(window).scroll(function() {
        let scrollTop = $(window).scrollTop();

        if(scrollTop > 40){
            $('body').addClass('scrolled');
        }else{
            $('body').removeClass('scrolled');
        }

        if (scrollTop > 500) {
            $('.toTop').addClass('show');
        }
        else {
            $('.toTop').removeClass('show');
        }
    });
})

function scrollTo(target, tab = false, offset = 100, scroll_speed = 800){
    if(tab){
        $('.tabs-nav li[data-tab="'+tab+'"]').click();
    }

    if( target.length ) {
        $('html, body').stop().animate({
            scrollTop: target.offset().top-offset
        }, scroll_speed);
    }
}
